import { MAIN_STYLE, MAIN_STYLE_GROUPS, PADDING_SIDES, PRESS_EVENTS } from '../shared.js'

export const badge = {
    parts: {
        main: {
            label: 'Main',
            exportSuffix: '',
            order: 0,
            propertyGroups: [...MAIN_STYLE_GROUPS],
            properties: {
                ...MAIN_STYLE,
                /* A badge is a circle by definition, and its 999 default below
                 * is the project's canonical "fully rounded" value (same as
                 * gauge/led/arc; the schema max, clamped to min(w,h)/2 at draw
                 * time, so a resized badge stays round without touching it).
                 * The firmware builds a badge on a plain lv_obj and has no
                 * circle default of its own, so the value has to travel on the
                 * wire even when the user never touched it — without
                 * exportAlways the optimizer strips it as "same as the widget
                 * default" and the plate renders a square. */
                radius: { type: 'int', min: 0, max: 999, exportAlways: true },
                border_color: { type: 'color', format: 'hex8' },
                border_opa: { type: 'int', min: 0, max: 255, internal: true },
                shadow_color: { type: 'color', format: 'hex8' },
                shadow_opa: { type: 'int', min: 0, max: 255, internal: true },
                padding: { type: 'int', min: 0, exportSpecial: true },
                ...PADDING_SIDES,
                text_color: { type: 'color', format: 'hex8', label: 'Text color' },
                text_font: { type: 'int', min: 8, label: 'Size (px)' },
                text_font_family: { type: 'string', internal: true },
                text_letter_space: { type: 'int', min: 0 },
                text_line_space: { type: 'int', min: 0 },
                text_opa: { type: 'int', min: 0, max: 255, internal: true },
            },
        },
    },

    properties: {
        x: { type: 'int' }, y: { type: 'int' },
        width: { type: 'int', min: 0 }, height: { type: 'int', min: 0 },
        min_width: { type: 'int', min: 0 }, min_height: { type: 'int', min: 0 },
        haspid: { type: 'int', min: 1, max: 254, internal: true },
        parentid: { type: 'int', min: 0, max: 254, internal: true },
        enabled: { type: 'bool' }, hidden: { type: 'bool' },
        text: { type: 'string', label: 'Text' },
        value: { type: 'float', label: 'Value' },
        value_str: { type: 'string', label: 'Value string' },
        text_font_resource: { type: 'resource', resourceType: 'font', label: 'Text Font Family', inline: true },
        text_ofs_x: { type: 'int', label: 'text offset x' },
        text_ofs_y: { type: 'int', label: 'text offset y' },
        value_font: { type: 'int', min: 8, label: 'Value Size (px)' },
        value_font_resource: { type: 'resource', resourceType: 'font', label: 'Value Font Family', inline: true },
        value_ofs_x: { type: 'int', label: 'value offset x' },
        value_ofs_y: { type: 'int', label: 'value offset y' },
        ring_width: { type: 'int', min: 0, label: 'Width' },
        ring_start_angle: { type: 'int', min: 0, max: 359, unit: '°', label: 'Start angle' },
        ring_segments: { type: 'array', label: 'Segments' },
        ring_source: { type: 'enum', values: ['manual', 'incoming', 'outgoing', 'all'], label: 'Ring source' },
        ring_reference: { type: 'enum', values: ['badge_value', 'flow_sum'], label: 'Ring reference' },
    },

    defaults: {
        properties: {
            x: 0, y: 0, width: 140, height: 140, min_width: 60, min_height: 60,
            enabled: true, hidden: false,
            text: 'Net', value: 0, value_str: '',
            text_font_resource: '', text_ofs_x: 0, text_ofs_y: 0,
            value_font: 16, value_font_resource: '', value_ofs_x: 0, value_ofs_y: 0,
            ring_width: 8, ring_start_angle: 270,
            ring_segments: [{ id: 'segment-1', name: 'Segment 1', value: 0, color: '#ff9800ff', enabled: true }],
            ring_source: 'manual', ring_reference: 'badge_value',
        },
        styles: {
            main: {
                bg_color: '#1c1c1cff',
                border_color: '#606060ff', border_width: 0,
                border_side: 15, radius: 999, padding: 14,
                text_color: '#ffffffff',
                text_font_family: 'Roboto Condensed', text_font: 16,
                text_letter_space: 0, text_line_space: 2,
            },
        },
    },

    states: ['pressed', 'disabled'],
    editorCapabilities: ['can_transform', 'can_copy', 'has_objectmenu', 'keep_ratio'],
    runtimeCapabilities: ['has_data'],
    events: PRESS_EVENTS,
    bindings: {
        properties: { x: {}, y: {}, w: {}, h: {}, val: {}, value_str: {}, text: {}, text_color: {}, text_font: {} },
        actions: { hass_services: [] },
        events: {},
    },
}
